const chargeType = contract => {
  if (!contract || contract === null || contract === undefined) return ''

  if (contract.postPaid) return 'Pós paga'

  return 'Pré paga'
}

export default chargeType
